// extracted by mini-css-extract-plugin
module.exports = {"CountriesFeature":"op_a"};